const config = {
  version: '2.7.5',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts